<template>
  <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" custom-class="dialogBox" :lock-scroll="false" :before-close="DialogClose" top="10vh" v-loading="disabled">
    <div class="dialogData">
      <div v-if="isAuction">
        <div class="new_price">
          <div>
             <!-- USD_Hprice:{{USD_Hprice}},Hprice:{{Hprice}}  -->
            <span class="price_bid" :class="{'text_greed':isbid,'text_red':(!isbid&&USD_Hprice>0)}">{{areaSymbol}} {{Hprice.toLocaleString()}}</span>
            <span v-if="USD_Hprice>0">{{$t('base.highestBidIs')}} {{areaSymbol}} {{USD_Hprice.toLocaleString()}}</span>
          </div>
          <div>
            <span :class="getCountDown(time)==1?'text_red':''">{{CountDown(time)}}</span>
            <span>{{setPlural(list.AuctionCount)}}</span>
          </div>
        </div>
        <div class="notification" v-if="isbid!=null">
          <span class="el-icon-warning text_red" v-if="!isbid"><span class="errorTxt">{{errorTxt}}</span></span>
          <span class="el-icon-success text_greed" v-if="isbid">{{successTxt}}</span>
          <div class="success_price_note" v-if="isbid">{{$t('colon.highBid')}}<span>{{areaSymbol}} {{MyPrice.toLocaleString()}}</span></div>
        </div>
        <div class="really_box" v-if="isbid">{{$t('alert.winBidTip')}}</div>
        <div>
          <el-collapse class="place_collapse" v-if="!isbid">
            <el-collapse-item class="place_collapse_title">
              <template slot="title">
                {{$t('title.bid')}}
              </template>
              <p class="place_collapse_p">{{$t('alert.bidTip')}}</p>
              <h4>{{$t('colon.bidTip')}}</h4>
              <p class="place_collapse_p" v-html="$t('alert.howBid')"></p>
            </el-collapse-item>
          </el-collapse>
          <div class="price_btn_bid" ref="price_btn_bid">
            <el-button type="primary" @click="addAuction(Hprice,1)" :disabled="disabled">{{areaSymbol}} {{judgeBid(Hprice,1).toLocaleString()}}
            </el-button>
            <el-button type="primary" @click="addAuction(Hprice,2)" :disabled="disabled">{{areaSymbol}} {{judgeBid(Hprice,2).toLocaleString()}}
            </el-button>
            <el-button type="primary" @click="addAuction(Hprice,4)" :disabled="disabled">{{areaSymbol}} {{judgeBid(Hprice,4).toLocaleString()}}
            </el-button>
          </div>
          <el-divider><span class="text_blue">{{$t('base.OR')}}</span></el-divider>
        </div>
        <div class="place_bid_ipt_box">
          <div class="justify_between">
            <!-- <el-input class="place_ipt" v-model="place_input" type="number" @keydown.native="e=>e.returnValue=(['e','E','-','+'].includes(e.key))?false:e.returnValue" oninput="if(value.indexOf('.') > 0){value=value.slice(0,value.indexOf('.') + 9)}"> -->
            <el-input class="place_ipt" v-model="place_input" type="text" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')">
              <template slot="prepend">{{areaSymbol}}</template>
            </el-input>
            <el-button type="primary" class="bidbtn" @click="placeBid(Hprice)" :disabled="disabled">{{$t('base.bid')}}</el-button>
          </div>
          <p class="text_gray bid_p">{{$t('alert.biddingTip')}}</p>
        </div>
      </div>
      <div v-if="!isAuction" class="chp_Box">
        <div v-if="list">{{$t('colon.needCHP')}} <strong>{{list.DepositNum}}</strong></div>
        <div v-if="list">{{$t('colon.youBalace')}} <strong :class="list.SumMoney>=list.DepositNum?'text_greed':'text_red'">{{list.SumMoney}}</strong></div>
        <div v-if="list&&(list.DepositNum>=list.SumMoney)">{{$t('alert.recharge')}}</div>
        <!-- <div>{{$t('alert.returnCHP')}} <br>{{$t('alert.deductCHP')}}</div> -->
        <div>{{$t('alert.returnCHP')}} </div>
      </div>
    </div>
   
    <span slot="footer" class="dialog-footer" v-if="!isAuction">
      <el-button @click="DialogClose">{{$t('base.cancel')}}</el-button>
      <el-button type="primary" @click="PayDeposit()" v-if="list&&(list.SumMoney>=list.DepositNum)" :disabled="disabled">{{$t('base.agree')}}</el-button>
      <el-button type="primary" @click="chpPay()" :disabled="disabled" v-else>{{$t('base.charge')}}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { countDown, setUTC, getInfo, getBid, numAdd, numMulti, numCeil, priceExchange, isNumber } from "@/api/public";
import qs from 'qs'
export default {
  name: '',
  data() {
    return {
      areaSymbol: this.$store.state.areaSymbol,
      successTxt: this.$t('alert.bidSuccess'),
      errorTxt: "",
      priceBid: '',
      userInfo: null,
      dialogType: 0,
      disabled: false,
      dialogVisible: false,
      isIntegral: false,
      isAuction: false,
      // dialogTitle: 'Something Important', 2022/11/16 nian
      dialogTitle: this.$t('base.CHPDesposit'),
      isbid: null,
      place_input: "",
      Hprice: "",
      MyPrice: 0,
      USD_Hprice: 0,
      nowData: new Date().getTime(),
      list: this.placeList,
    }
  },
  props: {
    Visible: Boolean,
    Auction: Boolean,
    time: String,
    placeList: {}
  },
  watch: {
    'Visible': {
      handler(val) {
        this.dialogVisible = val
      }
    },
    'placeList':{
      handler(val) {
        console.log(val,'placeList',this.USD_Hprice)
        this.list=this.placeList
      },
      deep: true
    },
    'list': {
      handler(val) {
        console.log(val,'list',this.USD_Hprice)
        this.setPlaceList(1)
      },
      deep: true
    },
    'Auction': {
      handler(val) {
        this.isAuction = val
        if (this.isAuction) {
          this.dialogTitle = this.$t('base.placeBid');
        }
      }
    }
  },
  filters: {
    //快速出价
    setBid(val, type) {
      let price = isNumber(val)
      let num = getBid(price)
      //this.judgeBid()
      return numCeil(numAdd(price, numMulti(num, type))).toLocaleString()
    },
  },
  created() {
    this.userInfo = getInfo();
    this.dialogVisible = this.Visible;
    this.isAuction = this.Auction;
    //this.getPrice();
    //console.log(this.list.newPlacePrice,'this.list.newPlacePrice')
    if (this.isAuction) {
      this.dialogTitle = this.$t('base.placeBid');
    }
    this.setPlaceList()
    this.cardTimer();

  },
  methods: {
    setPlaceList(type) {
      var that = this
      //console.log(that.list)
      try{
        that.Hprice = that.list.USD_Price;
        //console.log(that.Hprice,that.list.USD_Price,that.list.USD_HighestPrice,that.list.USD_HighestPrice,that.USD_Hprice,'setPlaceList')
        //that.list.USD_HighestPrice=isNumber(that.list.USD_HighestPrice)
        if(isNumber(that.list.USD_HighestPrice)>=that.USD_Hprice){
          that.USD_Hprice = isNumber(that.list.USD_HighestPrice);
          //console.log(that.USD_Hprice,'that.USD_Hprice')
        }
        //console.log(that.Hprice,that.USD_Hprice,that.Hprice>that.USD_Hprice)
        if(that.USD_Hprice>0){
        //console.log(that.USD_Hprice,that.list.Auctions[0].CreateUser)
          if(that.list.Auctions){
            if(that.list.Auctions[0].CreateUser == that.userInfo.MappingUserId){

                that.isbid = true;
                that.MyPrice=that.USD_Hprice
                that.successTxt = that.$t('alert.highestBidEnd')

              } else {
                that.isbid = false;
                that.errorTxt = that.$t('alert.increaseBid');
              }
          }else{

            if(that.list.IsOutBid){
              if(that.list.IsOutBid!=2){
                 that.isbid = true;
                that.MyPrice=that.USD_Hprice
                that.successTxt = that.$t('alert.highestBidEnd')

              } else {
                that.isbid = false;
                that.errorTxt = that.$t('alert.increaseBid');
              }
            }
          }
        }
        if(type!=1){
          if (that.list.newPlacePrice != undefined&&this.list.newPlacePrice!=null) {
            that.place_input = that.list.newPlacePrice;
            that.placeBid(that.Hprice)
          }
        }
      }catch(error){
        console.log(error,'bid')
      }
    },
    // 单双数
    setPlural(val) {
      let data = val
      if (data <= 1) {
        data = val +" "+ this.$t('base.bid')
      } else {
        data = val +" "+ this.$t('base.bids')
      }
      return data
    },
    //
    judgeBid(val, type) {
      let price = isNumber(val)
      if (isNumber(this.USD_Hprice) > val) {
        price = isNumber(this.USD_Hprice)
      }
      let num = getBid(price)
      let newPrice = 0;
      let p1 = numCeil(numAdd(price, numMulti(num, 1)))
      let p2 = numCeil(numAdd(price, numMulti(num, 2)))
      let p3 = numCeil(numAdd(price, numMulti(num, 4)))
      if (p1 == p2 && p2 == p3) {
        p2 = p1 + 1;
        p3 = p2 + 1;
      } else if (p1 == p2 && p2 != p3) {
        p2 = p1 + 1;
        if (p2 == p3) {
          p3 = p2 + 1
        }
      } else if (p1 != p2 && p2 == p3) {
        p3 = p2 + 1
      }
      if (type == 1) {
        newPrice = p1
      }
      if (type == 2) {
        newPrice = p2
      }
      if (type == 4) {
        newPrice = p3
      }
      return newPrice
    },
    //获取最新竞拍价格
    getPrice() {
      let that = this
      let data = { 'operator_id': this.userInfo.MappingUserId, 'memberid': this.userInfo.MappingUserId, 'token': this.userInfo.ChineseToken, 'CommodityID': this.list.ID }
      that.$get(that.$interface.AuctionIndex, data).then(res => {
        if (res.result != 0) {
          that.priceBid = res.data;
          if (isNumber(that.priceBid.USD_MyPrice) > 0) {
            that.Hprice = isNumber(that.priceBid.USD_MyPrice);
          }
          that.USD_Hprice = isNumber(that.priceBid.USD_HighestPrice);
        } else {
          that.$message.error(res.msg);
        }
      }).catch({})
    },
    // 设置倍率
    gotoPay(val, type) {
      let price = parseFloat(val)
      let num = getBid(price)
      return numCeil(numAdd(price, numMulti(num, type)))
    },
    DialogClose() {
      let nu = this.isbid
      this.isbid = null;
      this.dialogTitle = this.$t('base.somethingImportant');
      if (this.isAuction) {
        this.dialogTitle = this.$t('base.placeBid');
      }
      this.dialogVisible = false;
      //this.$emit('getDialog', this.dialogVisible, nu)
      this.$emit('getDialog', this.dialogVisible,this.list)
    },
    //
    chpPay() {
      let routeData = this.$router.resolve({ path: '/pay/chp' });
      window.open(routeData.href, '_blank');
    },
    // 缴纳保证金
    PayDeposit() {
      let that = this
      let data = { 'operator_id': this.userInfo.MappingUserId, 'memberid': this.userInfo.MappingUserId, 'token': this.userInfo.ChineseToken, 'CommodityID': this.list.ID, 'price': 0 }
      that.disabled = true
      this.$post(this.$interface.AuctionPayDeposit, qs.stringify(data)).then(res => {
        if (res.result != 0) {
          that.isAuction = true;
          that.dialogTitle = that.$t('base.placeBid');
          if (this.list.newPlacePrice != undefined&&this.list.newPlacePrice!=null) {
            this.place_input = this.list.newPlacePrice;
            this.placeBid(this.Hprice)
          }
        } else {
          that.isAuction = true;
        }
        that.disabled = false
      }).catch(error => { this.disabled = false })
    },
    // 输入框出价
    placeBid(val) {
      let that=this
      this.isbid = null;
      let num = isNumber(this.place_input)
      let price = isNumber(val)
      if (isNumber(this.USD_Hprice) > val) {
        price = isNumber(this.USD_Hprice)
      }
      if (!num) {
        this.isbid = false;
        this.errorTxt = this.$t('base.numberErr') //"please enter a number"
      } else {
        let num2 = this.gotoPay(price, 1)
        // console.log(num2,num)
        // 首次為競拍商品可以按基礎競拍價競拍
        // if(that.list.AuctionCount==0&&(num>=that.list.USD_Price)){
        //   this.isbid = null;
        //   this.addAuction(num, 1, 0)
        //   return 
        // }
        if (num2 > num) {
          this.isbid = false;
          // this.errorTxt = "You have to bid at least $ " + num2
          this.errorTxt = `${this.$t('base.plsBid',{n:num2})}`
        } else {
          this.isbid = null;
          this.addAuction(num, 1, 0)
        }
      }
      //this.getPrice();
    },
    // 快捷出价
    addAuction(val, type, s) {
      let that = this;
      let price = s != 0 ? this.judgeBid(isNumber(val), type) : isNumber(val);
      let ExPrice = priceExchange(price)
      let data = { 'operator_id': this.userInfo.MappingUserId, 'memberid': this.userInfo.MappingUserId, 'token': this.userInfo.ChineseToken, 'CommodityID': this.list.ID, 'price': ExPrice }
      

      const AddAuctionFunction=(data,price)=>{
        that.$post(that.$interface.AddAuction, qs.stringify(data)).then(res => {
          if (res.result == 1) {
            //that.getPrice()
            //that.Hprice = price
            that.MyPrice = price
            //console.log(that.Hprice,that.MyPrice,'AddAuctionFunction',res)
            that.getDetail(1);
          } else {
            //console.log('getDetail',0)
            that.getDetail(0);
            that.isbid = false;
            that.errorTxt = res.msg;
          }
          //that.disabled = false
        }).catch(error => {
          that.disabled = false
        })
      }
      if(that.isAuction){
        that.disabled = true
        if(price>numMulti(that.Hprice,50)){
          var html="<div class='text_center'>"+that.$t('alert.bidTooHigh')+"<br><span class='text_red weight_700'>USD "+price+"</span></div>"
          that.$confirm(html, that.$t('base.hint'), {
            confirmButtonText: that.$t('base.confirm'),
            cancelButtonText: that.$t('base.cancel'),
            lockScroll:false,
            dangerouslyUseHTMLString:true,
          }).then(() => {
            AddAuctionFunction(data,price)
          }).catch(() => {   
            that.disabled = false      
          });
        }else{
            AddAuctionFunction(data,price)
        }
      }
    },
    // 商品详情 val 1:埋价
    getDetail(val) {
      //this.userInfo
      let that = this;
      let data = { 'memberid': that.userInfo.MappingUserId, 'token': that.userInfo.ChineseToken, 'operator_id': that.userInfo.MappingUserId, 'CommodityID': this.list.ID,buyerSource:that.userInfo.MemberSource }
      that.$get(that.$interface.DetailCommodity, data).then(res => {
        if (res.result != 0) {
          let result = res.data
          if (val != 0) {
            if (result.Auctions[0].CreateUser == that.userInfo.MappingUserId) {
              that.isbid = true;
              that.successTxt = that.$t('alert.highestBidEnd')

            } else {
              that.isbid = false;
              that.errorTxt = that.$t('alert.increaseBid');
            }
          }
          //that.list.AuctionCount=result.AuctionCount
          //that.list.Auctions=result.Auctions
          that.Hprice = result.USD_Price;
          //console.log(that.Hprice,result.USD_Price,'getDetail',val,val == 1)
          if (val == 1) {
            that.USD_Hprice = isNumber(result.USD_HighestPrice);
          //console.log(that.USD_Hprice,result.USD_HighestPrice,'val == 1')
          }
          result.isbid=that.isbid
          result.successTxt=that.successTxt
          result.errorTxt=that.errorTxt
          try{
            result.DepositNum=that.list.DepositNum
            result.SumMoney=that.list.SumMoney
          }catch(error){}
          that.list=result
          that.disabled = false
        }
      })
    },
    cardTimer() {
      this.timer = setInterval(() => {
        this.nowData = this.nowData + 1000;
      }, 1000);
    },
    CountDown(itemEnd) {
      if (itemEnd) {
        itemEnd = itemEnd.toString().replace(/-/g, "/")
      }
      //console.log(itemEnd)
      let val = setUTC(itemEnd, -8, 'cn')
      let newval = setUTC(this.nowData, -8)
      return countDown(val, this.nowData)
    },
    getCountDown(itemEnd) {
      if (itemEnd) {
        itemEnd = itemEnd.toString().replace(/-/g, "/")
      }
      //console.log(itemEnd)
      let val = setUTC(itemEnd, -8, 'cn')
      let newval = setUTC(this.nowData, -8)
      return countDown(val, this.nowData, 2)
    },
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.place_bid_ipt_box {
  padding: 16px 0 0;
}

/deep/ .place_bid_ipt_box .place_ipt {
  height: 40px;
  /* margin-right: 22px; */
}

/deep/ .place_bid_ipt_box .place_ipt .el-input__inner {
  height: 40px;
  line-height: 40px;
}

/deep/ .place_bid_ipt_box .bidbtn {
  font-size: 16px;
  line-height: 1.1;
}

.bid_p {
  margin-top: 16px;
  line-height: 19.6px;
}

.price_btn_bid {
  justify-content: inherit;
  flex-wrap: wrap;
  padding: 8px 0;
}

.price_btn_bid .el-button {
  min-width: 28.68%;
  max-width: 100%;
  margin-top: 12px;
  /*margin-right: 24px;*/
  margin-right: 20px;
  margin-left: 0;
  font-size: 16px;
  line-height: 1.3;
}

.price_btn_bid .el-button:last-child {
  margin-right: 0px;
  margin-top: 10px;
}

.price_btn_bid .el-button+.el-button {
  /* margin-left: 16px; */
  /* margin-top: 12px; */
  /* margin-right: 24px; */
}

.notification {
  font-size: 14px;
  padding: 12px;
  background-color: #f7f7f7;
  border-radius: 4px;
}

.notification span {
  font-weight: bold;
}

.really_box {
  margin: 16px 0 8px;
}

.new_price>div {
  color: #a0a0a0;
  margin-bottom: 10px;
}

.new_price .price_bid {
  color: #333;
  font-size: 20px;
  font-weight: bold;
}

.new_price .text_greed {
  color: #57a800;
}
.new_price .text_red {
  color: #E02020;
}

.new_price>div span {
  margin-right: 12px;
}

.success_price_note {
  margin-top: 12px;
}

.success_price_note span {
  font-size: 24px;
  margin-left: 8px;
}

.chp_Box>div {
  margin-bottom: 12px;
}

.chp_Box>div:last-child {
  margin-bottom: 0;
}

.errorTxt {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.place_collapse_p {
  font-size: 14px;
  line-height: 19.6px;
}

.place_collapse_title h4 {
  font-size: 18px;
  font-weight: normal;
  line-height: 1;
  padding: 12px 0 8px;
}

.el-divider--horizontal {
  margin: 6px 0;
}

.price_btn_bid .el-button {
  margin-top: 0;
}

.price_btn_bid {
  padding: 10px 0 16px;
}

/deep/.el-dialog__body {
  padding: 10px 20px 24px !important;
}

/deep/ .el-collapse-item__arrow.is-active {
  transform: rotate(-90deg);
}

/deep/ .el-collapse-item__header:hover {
  color: #333;
}

/deep/ .el-dialog__body {
  padding: 8px 20px 24px;
}

</style>



// WEBPACK FOOTER //
// src/components/dialog/placebid.vue